import React, { useState } from 'react';
import { compose } from 'recompose';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { lightTheme } from '../../layout/MyLayout';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { translate, showNotification } from 'react-admin';
import { connect } from 'react-redux';
import { isPermissiveAsAccountManager } from '../../const/Role';

const contentStyle = { marginLeft: '5em' };

const PrivilegedAccount = ({ config, getConfig, updateConfig, translate, showNotification, permissions }) => {
  const [isFocus, setIsFocus] = useState(true);

  const onFocus = async () => {
    if (!isFocus) {
      await getConfig();
    }
    setIsFocus(true);
  };

  const onBlur = () => {
    setIsFocus(false);
  };

  const onDelink = async e => {
    var options = {
      method: 'POST',
      credentials: 'include',
      mode: 'cors',
    };
    var request = new Request(process.env.REACT_APP_RSB_API_ENDPOINT + '/auth-calendar/outlook/delink');
    fetch(request, options)
      .then(() => {
        //成功の場合
        updateConfig({ ...config, calendarAdminName: '' });
      })
      .catch(e => showNotification('ra.message.error', 'warning'));
  };

  return (
    <MuiThemeProvider theme={lightTheme}>
      <Card onFocus={onFocus} onBlur={onBlur}>
        <List>
          <ListItem>
            <ListItemText
              primary={translate('privilegedAccount.title')}
              secondary={
                <Typography style={{ color: 'gray' }}>{translate('privilegedAccount.notification')}</Typography>
              }
            />
          </ListItem>
          <ListItem style={contentStyle}>
            <ListItemText
              primary={translate('privilegedAccount.configuredAccount')}
              secondary={`${
                config.calendarAdminName ? config.calendarAdminName : translate('privilegedAccount.notSettingYet')
              }`}
              style={{ maxWidth: '250px' }}
            />
            {isPermissiveAsAccountManager(permissions) && config.calendarAdminName && (
              <Button variant="contained" color="secondary" onClick={onDelink} style={{ minWidth: 120 }}>
                {translate('privilegedAccount.delink')}
              </Button>
            )}
          </ListItem>
        </List>
      </Card>
    </MuiThemeProvider>
  );
};

const enhance = compose(translate, connect(undefined, { showNotification }));
export default enhance(PrivilegedAccount);
